import {createMuiTheme} from "@material-ui/core";

export const Theme = createMuiTheme({
    palette: {
        primary: {
            light: '#6A4F4B',
            main: '#3E2723',
            dark: '#1B0000',
            contrastText: '#FFFFFF',
        },
        secondary: {
            light: '#629749',
            main: '#33691E',
            dark: '#003D00',
            contrastText: '#FFFFFF',
        },
        error: {
            main: '#CC0000',
        }
    },
});
